import { useRef, useState } from 'react';
import { toast } from 'sonner';
import { Upload, FileCheck2, Loader2, X } from 'lucide-react';
import { market } from '../lib/api';

export const DOC_LABELS = {
  pan_card: 'PAN card', gst_certificate: 'GST certificate', udyam_certificate: 'Udyam / MSME certificate',
  cancelled_cheque: 'Cancelled cheque / bank proof', trademark_or_authorisation: 'Trademark certificate or brand authorisation',
  brand_authorisation_letter: 'Brand authorisation letter', manufacturing_licence: 'Manufacturing licence',
  certification: 'Certification (BIS, ISO, FSSAI…)', factory_photo: 'Factory photo', product_photo: 'Product photo',
  product_catalogue: 'Product catalogue', business_registration: 'Business registration', other: 'Other document',
};

export default function PartnerDocUpload({ kind, required, docs, onAdd, onRemove }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const mine = docs.filter(d => d.kind === kind);

  const pick = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try { onAdd(await market.uploadDoc(f, kind)); toast.success(`${DOC_LABELS[kind]} uploaded`); }
    catch (err) { toast.error(err?.response?.data?.detail || 'Upload failed'); }
    finally { setBusy(false); if (ref.current) ref.current.value = ''; }
  };

  return (
    <div data-testid={`doc-${kind}`} className="rounded-xl border border-border bg-white p-3">
      <div className="flex items-center justify-between gap-2">
        <div className="text-sm font-semibold">{DOC_LABELS[kind]} {required && <span className="text-[#B71C1C]">*</span>}</div>
        <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp,application/pdf" className="hidden" onChange={pick} data-testid={`doc-${kind}-input`}/>
        <button type="button" data-testid={`doc-${kind}-btn`} onClick={() => ref.current?.click()} disabled={busy}
          className="btn-outline !py-1.5 !px-3 text-xs">{busy ? <Loader2 className="w-3.5 h-3.5 animate-spin"/> : <Upload className="w-3.5 h-3.5"/>}Upload</button>
      </div>
      {mine.map(d => (
        <div key={d.url} className="mt-2 flex items-center gap-2 text-xs text-[#1B5E20]">
          <FileCheck2 className="w-3.5 h-3.5"/><span className="truncate flex-1">{d.name}</span>
          <button type="button" onClick={() => onRemove(d.url)} aria-label="Remove" className="text-ink/50 hover:text-[#B71C1C]"><X className="w-3.5 h-3.5"/></button>
        </div>
      ))}
    </div>
  );
}
